const currentHost = window.location.host;
(PageInits = {
    collection: function (e) {
        var t = 0,
            a = $(e),
            i = ("eH" + Math.random()).replace(".", "");
        a.each(function () {
            var e = $(this).offset().top;
            t < e && ($("." + i).removeClass(i), (t = e)), $(this).addClass(i), $(this).css("min-height", "auto");
            var a = Math.max.apply(
                null,
                $("." + i)
                    .map(function () {
                        return $(this).outerHeight();
                    })
                    .get()
            );
            $("." + i).css("min-height", a);
        }).removeClass(i);
    },
}),
    $(document).ready(function () {
        function e(e) {
            jQuery
                .ajax({
                    url: `//${currentHost}/api/2023-01/graphql.json`,
                    method: "POST",
                    headers: { "X-Shopify-Storefront-Access-Token": `${window.apiToken}`, "Content-Type": "application/graphql" },
                    data: `query { productByHandle ( handle:"${e}"){ id title priceRange { maxVariantPrice {amount} } handle tags images(first:1) { edges { node { url } } } media(first: 50) { edges { node { __typename ... on MediaImage { id mediaContentType alt image { url } }  ... on Video { id sources { format url } } ... on ExternalVideo { id embeddedUrl } __typename } } } variants(first: 100){ edges { node { title id price { amount currencyCode } availableForSale quantityAvailable image { url } }}}}}`,
                })
                .done(function (e) {
                    $("select[name=id]").empty();
                    let t = e.data.productByHandle,
                        a = t.media.edges,
                        i = 100 * t.priceRange.maxVariantPrice.amount;
                    $(".ProductMeta__Price.Price").text(theme.formatMoney(i, theme.moneyFormat));
                    var s = t.id,
                        o = (s = s.split("/"))[s.length - 1];
                    $("form.ProductForm").attr("id", "product_form_" + o),
                        $(".js-media").empty(),
                        $(".onloadSkeleton").css("display", "block"),
                        $(".pdp_swatch_skeleton").css("display", "block"),
                        $(".pdp_size_skeleton").css("display", "block"),
                        $(window).scrollTop(0),
                        $(".js-media").css("content-visibility", "hidden"),
                        $(".Swatches").css("display", "none"),
                        $(".product-size").css("display", "none");
                    let d = async (e) => {
                        for (let t = 0; t < e.length; t++) {
                            var a = e[t].node.__typename;
                            switch (a) {
                                case "MediaImage":
                                    var i = e[t].node.id,
                                        s = (i = i.split("/"))[i.length - 1],
                                        o = e[t].node.image.url,
                                        d = e[t].node.alt,
                                        r =
                                            '<div id="Media' +
                                            s +
                                            '" tabindex="0" class="Product__SlideItem Product__SlideItem--image Carousel__Cell" data-media-type="' +
                                            a +
                                            '" data-media-id="' +
                                            s +
                                            '" data-media-position="' +
                                            t +
                                            '" data-image-media-position="' +
                                            t +
                                            '"><div class="AspectRatio AspectRatio--square" style="--aspect-ratio: 1.0;"><img  class="Image--fadeIn lazyautosizes Image--lazyLoaded"  data-widths="[200,400,600,700,800,900,1000,1200]"  data-sizes="auto"  data-expand="-100"  alt="' +
                                            d +
                                            '"  data-max-width="1200"  data-max-height="1200"  data-original-src="' +
                                            o +
                                            '"  data-srcset="' +
                                            o +
                                            '"  sizes="375px" srcset="' +
                                            o +
                                            '"><span class="Image__Loader"></span><noscript><img src="' +
                                            o +
                                            '" alt="' +
                                            d +
                                            '"></noscript></div><div class="Icon Icon--ZOOM_CIRCLE"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(-419 -430)"><g transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></div>';
                                    $(".js-media").append(r);
                                    break;
                                case "Video":
                                    var l = e[t].node.id,
                                        n = (l = l.split("/"))[l.length - 1],
                                        c = e[t].node.sources[2].url,
                                        p = e[t].node.sources[2].format,
                                        m =
                                            '<div id="Media' +
                                            n +
                                            '" tabindex="-1" class="Product__SlideItem Product__SlideItem--video Carousel__Cell" data-media-type="VIDEO" data-media-id="' +
                                            n +
                                            '" data-media-position="' +
                                            t +
                                            '"><div class="Image--lazyLoad Image--fadeIn" data-expand="-100"><div class="VideoWrapper VideoWrapper--native" id="video_' +
                                            n +
                                            '"></div></div></div>';
                                    $(".js-media").append(m);
                                    var u = $("<video />", { id: "video", src: c, type: "video/" + p, controls: !0, autoplay: !0, muted: !0 });
                                    $("#video_" + n).append(u);
                                    break;
                                case "ExternalVideo":
                                    var h = e[t].node.id,
                                        v = (h = h.split("/"))[h.length - 1],
                                        g = e[t].node.embeddedUrl.split("/"),
                                        m =
                                            '<div id="Media' +
                                            v +
                                            '" tabindex="-1" class="Product__SlideItem Product__SlideItem--video Carousel__Cell" data-media-type="' +
                                            a +
                                            '" data-media-id="' +
                                            v +
                                            '" data-media-position="' +
                                            t +
                                            '" data-video-host="youtube" data-video-id="' +
                                            v +
                                            '"><div class="Image--lazyLoad Image--fadeIn" data-expand="-100"><div class="VideoWrapper"><iframe id="' +
                                            v +
                                            '" width="640" height="360" src="http://www.youtube.com/embed/' +
                                            g[g.length - 1] +
                                            '" frameborder="0"></iframe></div></div></div>';
                                    $(".js-media").append(m);
                                    break;
                                default:
                                    var r =
                                        '<div id="Media' +
                                        s +
                                        '" tabindex="0" class="Product__SlideItem Product__SlideItem--image Carousel__Cell is-selected" data-media-type="' +
                                        a +
                                        '" data-media-id="' +
                                        s +
                                        '" data-media-position="' +
                                        t +
                                        '" data-image-media-position="' +
                                        (t - 1) +
                                        '"><div class="AspectRatio AspectRatio--square" style="--aspect-ratio: 1.0;"><img  class="Image--fadeIn lazyautosizes Image--lazyLoaded"  data-widths="[200,400,600,700,800,900,1000,1200]"  data-sizes="auto"  data-expand="-100"  alt="' +
                                        d +
                                        '"  data-max-width="1200"  data-max-height="1200"  data-original-src="' +
                                        o +
                                        '"  data-srcset="' +
                                        o +
                                        '"  sizes="375px" srcset="' +
                                        o +
                                        '"><span class="Image__Loader"></span><noscript><img src="' +
                                        o +
                                        '" alt="' +
                                        d +
                                        '"></noscript></div><div class="Icon Icon--ZOOM_CIRCLE"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(-419 -430)"><g transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></div>';
                                    $(".js-media").append(r);
                            }
                        }
                        return e;
                    };
                    d(a).then(function (e) {
                        $(".onloadDots").remove(),
                            $(".pdp_media_skeleton").css("display", "none"),
                            $(".onloadSkeleton").css("display", "none"),
                            $(".pdp_swatch_skeleton").css("display", "none"),
                            $(".pdp_size_skeleton").css("display", "none"),
                            $(window).scrollTop(0),
                            $(".js-media").css("content-visibility", "visible"),
                            $(".Swatches").css("display", "flex"),
                            $(".product-size").css("display", "block"),
                            $(".js-media.Mobile").flickity({
                                prevNextButtons: !1,
                                pageDots: !0,
                                adaptiveHeight: !1,
                                watchCSS: !0,
                                dragThreshold: 50,
                                draggable: !0,
                                initialIndex: 0,
                                arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
                            });
                    });
                });
        }
        function t() {
            769 > $(window).width()
                ? document.querySelectorAll(".js-tab-heading").forEach((e) => {
                      let t = new Flickity(e, { contain: !0, prevNextButtons: !1, pageDots: !1, cellAlign: "center" });
                      t.on("staticClick", function (e, a, i, s) {
                          i && t.selectCell(i, !1, !1);
                      });
                  })
                : document.querySelectorAll(".js-tab-heading").forEach((e) => {
                      Flickity.data(e) && Flickity.data(e).destroy();
                  });
        }
        $(".js-media.Mobile").flickity({ prevNextButtons: !1, pageDots: !1, adaptiveHeight: !1, watchCSS: !0, dragThreshold: 50, draggable: !1, initialIndex: 0, arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 } }),
            $("[data-action='apply-tags']").length && $(".CollectionMain .is-active").length && $("[data-action='apply-tags']").click(),
            t(),
            $(window).resize(function () {
                t();
            }),
            $(document).on("click", ".footer-stores-btn", function () {
                $(".footer-stores-btn").attr("aria-expanded", "true"), $("#footer-stores-popover").attr("aria-hidden", "false"), $(".PageOverlay").addClass("is-visible");
            }),
            $("#footer-stores-popover .Popover__Close").on("click", function () {
                $(".footer-stores-btn").attr("aria-expanded", "false"), $("#footer-stores-popover").attr("aria-hidden", "true"), $(".PageOverlay").removeClass("is-visible");
            }),
            $(document).on("click", ".PageOverlay.is-visible", function () {
                $(".footer-stores-btn").attr("aria-expanded", "false"), $("#footer-stores-popover").attr("aria-hidden", "true");
            }),
            $(document).on("click", ".collapse .collapse__button", function () {
                let e = $(this).parent(),
                    t = e.data("options") || {},
                    a = { slideUpDuration: 200, slideDownDuration: 200, ...t };
                e.hasClass("collapse--active")
                    ? (e.removeClass("collapse--active"), $(this).next(".collapse__body").slideUp(a.slideUpDuration))
                    : (e.addClass("collapse--active"), $(this).next(".collapse__body").slideDown(a.slideDownDuration));
            }),
            $(document).on("click", ".dropdown .dropdown__button", function () {
                let e = $(this).parent();
                e.hasClass("dropdown--active") ? e.removeClass("dropdown--active") : e.addClass("dropdown--active");
            }),
            $(".dropdown__list__link").on("click", function () {
                $(this).closest(".dropdown").removeClass("dropdown--active");
            }),
            $(document).on("click", (e) => {
                let t = $(".dropdown");
                t.is(e.target) || 0 !== t.has(e.target).length || t.removeClass("dropdown--active");
            }),
            $(document).on("click", ".Drawer__Close.Icon-Wrapper--clickable", function () {
                $("body").removeClass("no-scroll"),
                    $(".PageOverlay").removeClass(" is-visible"),
                    $("#sidebar-cart").removeAttr("tabindex", "-1"),
                    $("#sidebar-cart").removeAttr("aria-hidden", "false"),
                    $(".country-list").removeAttr("style");
            }),
            $(document).on("click", ".PageOverlay.is-visible", function () {
                $("body").removeClass("no-scroll"), $(".PageOverlay").removeClass("is-visible"), $("#sidebar-cart").removeAttr("tabindex", "-1"), $("#sidebar-cart").removeAttr("aria-hidden", "false");
            }),
            $(document).on("click", ".Header__Icon.Icon-Wrapper--clickable", function () {
                $(".country-list").removeAttr("style");
            }),
            $(document).on("click", ".Sizes .Heading", function () {
                $(this).hasClass("open") ? ($(this).removeClass("open"), $(this).next(".SizesWrapper").slideUp(200)) : ($(this).addClass("open"), $(this).next(".SizesWrapper").slideDown(200));
            }),
            $(document).on("click", ".variantSelector", async function (e) {
                let t = $(this).data("tag_name"),
                    a = $(this).data("url"),
                    i = $(this).find("img").attr("srcset"),
                    s = $(this).data("pid"),
                    o = "" == $(this).data("title") ? $(this).parent().data("title") : $(this).data("title"),
                    d = parseInt($(this).parent().data("price")),
                    r = parseInt($(this).parent().data("price-compare")),
                    l = $(this).parents(".ProductItem__Wrapper").find(".ProductItem__PriceList"),
                    n = { isPreorder: $(this).data("preorder"), preorderText: $(this).data("preorder-text"), preorderColor: $(this).data("preorder-color") };
                r > d
                    ? l.html(`
        <span class="ProductItem__Price Price Price--highlight Text--subdued">${theme.formatMoney?.(d, theme.moneyFormat)}</span>
        <span class="ProductItem__Price Price Price--compareAt Text--subdued">${theme.formatMoney?.(r, theme.moneyFormat)}</span>
      `)
                    : l.html(`
        <span class="ProductItem__Price Price Text--subdued">${theme.formatMoney?.(d, theme.moneyFormat)}</span>
      `),
                    $(this).parents(".ProductItem__Swatches").find(".SwatchButton").removeClass("block-selected"),
                    $(this).addClass("block-selected"),
                    await (function e(t, a, i, s, o, d, r) {
                        let l = $(r).closest(".ProductItem__Wrapper"),
                            n = l.find(".ProductItem__ImageWrapper .AspectRatio"),
                            c = $(r).parent(".SwatchItem")?.attr("data-tags").split(",") || [],
                            p = c?.filter((e) => e.includes("LABEL_")),
                            m = `${o}`.split("|"),
                            u = a.split("/products/", 1)[0].concat(`/products/${t}`),
                            h = $("#collection_handle").data("template"),
                            v = null;
                        if (
                            (d.isPreorder &&
                                (v = $("<span>"))
                                    .addClass("ProductItem__PreorderText")
                                    .css("color", d.preorderColor)
                                    .text(" " + d.preorderText),
                            $("[data-product_show='" + s + "']")
                                .parents(".ProductItem__Wrapper")
                                .find(".ProductItem__PreorderText")
                                ?.remove(),
                            v &&
                                $("[data-product_show='" + s + "']")
                                    .parents(".ProductItem__Wrapper")
                                    .find(".ProductItem__Title.Heading a")
                                    .append(v),
                            $("[data-product_show='" + s + "']")
                                .parents(".ProductItem__Wrapper")
                                .find(".linkChange")
                                .attr("href", u),
                            n.find(".ProductItem__Badges").remove(),
                            p)
                        ) {
                            let g = $("<div class='ProductItem__Badges'></div>");
                            p?.forEach((e) => {
                                g.append(`<div class="ProductItem__Badge">${window.languages[e]}</div>`);
                            }),
                                n.append(g);
                        }
                        "template-A" == h
                            ? ($("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".linkChange")
                                  .attr("href", u),
                              $("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.Heading a")
                                  .attr("href", u),
                              $("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.Sub_title")
                                  .text(m[m.length - 1]),
                              $("[data-img_id='" + s + "']").attr("srcset", i),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList")
                                  .each(function () {
                                      $(this).addClass("no-js");
                                  }),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList.quick-add-sizes-for_" + t)
                                  .removeClass("no-js"))
                            : "template-B" == h
                            ? ($("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".linkChange")
                                  .attr("href", u),
                              $("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.Heading a")
                                  .attr("href", u),
                              $("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.Sub_title")
                                  .text(m[m.length - 1]),
                              $("[data-img_id='" + s + "']").attr("srcset", i),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList")
                                  .each(function () {
                                      $(this).addClass("no-js");
                                  }),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList.quick-add-sizes-for_" + t)
                                  .removeClass("no-js"))
                            : ($("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.Heading a")
                                  .attr("href", u),
                              $("[data-product_show='" + s + "']")
                                  .parents(".ProductItem__Wrapper")
                                  .find(".ProductItem__Title.subTitle")
                                  .text(m[m.length - 1]),
                              $("[data-img_id='" + s + "']").attr("srcset", i),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList")
                                  .each(function () {
                                      $(this).addClass("no-js");
                                  }),
                              $("[data-product_show='" + s + "']")
                                  .find(".SizesList.quick-add-sizes-for_" + t)
                                  .removeClass("no-js"));
                    })(t, a, i, s, o, n, this);
            }),
            $(document).on("click", ".changeVariant", function () {
              
                let e = $(this).data("swatch-url");
                if ((window.dispatchEvent(new CustomEvent("custom:swatch-change", { detail: { url: e } })), !$(this).hasClass("disable-select") && !$(this).hasClass("onHome"))) {
                    let t = $(this).data("tag_name"),
                        a = $(this).data("collection"),
                        i = $(this).data("url"),
                        s = !1;
                    s = "" !== a;
                    let o = i.split("/products/", 1)[0].concat(`/products/${t}`);
                    if ((s && (o = i.split("/products/", 1)[0].concat(`/collections/${a}/products/${t}`)), history.pushState)) {
                        var d,
                            r = window.location.protocol + "//" + window.location.host + o;
                        window.history.pushState({ path: r }, "", r),
                            $('link[rel="canonical"]').attr("href", r),
                            (d = t),
                            $(".js-media.Mobile").flickity("destroy"),
                            $(".onloadSkeleton").css("display", "none"),
                            $(".pdp_media_skeleton").css("display", "flex"),
                            jQuery
                                .ajax({
                                    url: `//${currentHost}/api/2023-01/graphql.json`,
                                    method: "POST",
                                    headers: { "X-Shopify-Storefront-Access-Token": `${window.apiToken}`, "Content-Type": "application/graphql" },
                                    data: `query { productByHandle ( handle:"${d}"){ id title handle tags images(first:1) { edges { node { url } } } media(first: 50) { edges { node { __typename ... on MediaImage { id mediaContentType alt image { url } }  ... on Video { id sources { format url } } ... on ExternalVideo { id embeddedUrl } __typename } } } variants(first: 100){ edges { node { title id price { amount currencyCode } compareAtPrice { amount currencyCode } availableForSale quantityAvailable image { url } }}}}}`,
                                })
                                .done(function (e) {

                                    /*Update Badge and Model*/
                                    if ( document.querySelector(".nd-product-tags") ) { 
                                      var badges = e.data.productByHandle.tags.filter((tag) => tag.includes('LABEL_') || tag == 'TAG_Privada' );

                                      var badgesContent = badges.map((badge) => {                                    
                                        return `<div class="product-card__badge">${window.languages[badge]}</div>`
                                      })
                                      document.querySelector(".nd-product-tags").innerHTML = badgesContent.join('');
                                    }
                                    /*----*/
                                    $("select[name=id]").empty();
                                    let t = e.data.productByHandle,
                                        a = t.media.edges;
                                    var i = t.id,
                                        s = (i = i.split("/"))[i.length - 1];
                                    $("form.ProductForm").attr("id", "product_form_" + s);
                                    let o = Math.round(100 * t.variants.edges[0].node.price.amount),
                                        d = Math.round(100 * (t.variants.edges[0].node.compareAtPrice?.amount || 0)),
                                        r = $(".ProductMeta__PriceList");

                                    /* Update Discount*/
                                    let percentajeDiscount = Math.round((d - o) * 100 / d);
                                    if (d > o && percentajeDiscount > 0) {
                                      document.querySelector(".nd-product-tags").innerHTML = badgesContent.join('');
                                      document.querySelector(".nd-product-tags").insertAdjacentHTML("afterbegin", "<div class='product-card__badge ProductMeta__DiscountBadge'>-"+percentajeDiscount+"%</div>");
                                    }
                                    /*----*/
                                    d > o
                                        ? r.html(`
                                        <span class="ProductMeta__Price Price--compareAt Text--strikethrough u-h4">${theme.formatMoney(d, theme.moneyFormat)}</span>
                                        <span class="ProductMeta__Price Price--highlight Text--subdued u-h4">${theme.formatMoney(o, theme.moneyFormat)}</span>
                                        `)
                                        : r.html(`
                                          <span class="ProductMeta__Price Price Text--subdued">${theme.formatMoney(o, theme.moneyFormat)}</span>
                                        `),
                                        $(".js-media").empty(),
                                        $(".onloadSkeleton").css("display", "block"),
                                        $(".pdp_swatch_skeleton").css("display", "block"),
                                        $(".pdp_size_skeleton").css("display", "block"),
                                        $(window).scrollTop(0),
                                        $(".js-media").css("content-visibility", "hidden"),
                                        $(".Swatches").css("display", "none"),
                                        $(".product-size").css("display", "none");
                                    let l = async (e) => {
                                        for (let t = 0; t < e.length; t++) {
                                            var a = e[t].node.__typename;
                                            console.log(a);
                                            switch (a) {
                                                case "MediaImage":
                                                    var i = e[t].node.id,
                                                        s = (i = i.split("/"))[i.length - 1],
                                                        o = e[t].node.image.url,
                                                        d = e[t].node.alt,
                                                        r =
                                                            '<div id="Media' +
                                                            s +
                                                            '" tabindex="0" class="Product__SlideItem Product__SlideItem--image Carousel__Cell" data-media-type="' +
                                                            a +
                                                            '" data-media-id="' +
                                                            s +
                                                            '" data-media-position="' +
                                                            t +
                                                            '" data-image-media-position="' +
                                                            t +
                                                            '"><div class="AspectRatio AspectRatio--square" style="--aspect-ratio: 1.0;"><img  class="Image--fadeIn lazyautosizes Image--lazyLoaded"  data-widths="[200,400,600,700,800,900,1000,1200]"  data-sizes="auto"  data-expand="-100"  alt="' +
                                                            d +
                                                            '"  data-max-width="1200"  data-max-height="1200"  data-original-src="' +
                                                            o +
                                                            '"  data-srcset="' +
                                                            o +
                                                            '"  sizes="375px" srcset="' +
                                                            o +
                                                            '"><span class="Image__Loader"></span><noscript><img src="' +
                                                            o +
                                                            '" alt="' +
                                                            d +
                                                            '"></noscript></div><div class="Icon Icon--ZOOM_CIRCLE"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(-419 -430)"><g transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></div>';
                                                    $(".js-media").append(r);
                                                    break;
                                                case "Video":
                                                    var l = e[t].node.id,
                                                        n = (l = l.split("/"))[l.length - 1],
                                                        c = e[t].node.sources[2].url,
                                                        p = e[t].node.sources[2].format,
                                                        m =
                                                            '<div id="Media' +
                                                            n +
                                                            '" tabindex="-1" class="Product__SlideItem Product__SlideItem--video Carousel__Cell" data-media-type="VIDEO" data-media-id="' +
                                                            n +
                                                            '" data-media-position="' +
                                                            t +
                                                            '"><div class="Image--lazyLoad Image--fadeIn" data-expand="-100"><div class="VideoWrapper VideoWrapper--native video_' +
                                                            n +
                                                            '" id="video_' +
                                                            n +
                                                            '" style="padding-bottom: 100.0%"></div></div></div>';
                                                    $(".js-media").append(m);
                                                    var u = $("<video />", { id: "video", src: c, type: "video/" + p, controls: !1, autoplay: !0, muted: !0, playsinline: !0, loop: !0 });
                                                    $(".video_" + n).append(u);
                                                    break;
                                                case "ExternalVideo":
                                                    var h = e[t].node.id,
                                                        v = (h = h.split("/"))[h.length - 1],
                                                        g = e[t].node.embeddedUrl.split("/"),
                                                        m =
                                                            '<div id="Media' +
                                                            v +
                                                            '" tabindex="-1" class="Product__SlideItem Product__SlideItem--video Carousel__Cell" data-media-type="' +
                                                            a +
                                                            '" data-media-id="' +
                                                            v +
                                                            '" data-media-position="' +
                                                            t +
                                                            '" data-video-host="youtube" data-video-id="' +
                                                            v +
                                                            '"><div class="Image--lazyLoad Image--fadeIn" data-expand="-100"><div class="VideoWrapper"><iframe id="' +
                                                            v +
                                                            '" width="640" height="360" src="http://www.youtube.com/embed/' +
                                                            g[g.length - 1] +
                                                            '" frameborder="0"></iframe></div></div></div>';
                                                    $(".js-media").append(m);
                                                    break;
                                                default:
                                                    var r =
                                                        '<div id="Media' +
                                                        s +
                                                        '" tabindex="0" class="Product__SlideItem Product__SlideItem--image Carousel__Cell is-selected" data-media-type="' +
                                                        a +
                                                        '" data-media-id="' +
                                                        s +
                                                        '" data-media-position="' +
                                                        t +
                                                        '" data-image-media-position="' +
                                                        (t - 1) +
                                                        '"><div class="AspectRatio AspectRatio--square" style="--aspect-ratio: 1.0;"><img  class="Image--fadeIn lazyautosizes Image--lazyLoaded"  data-widths="[200,400,600,700,800,900,1000,1200]"  data-sizes="auto"  data-expand="-100"  alt="' +
                                                        d +
                                                        '"  data-max-width="1200"  data-max-height="1200"  data-original-src="' +
                                                        o +
                                                        '"  data-srcset="' +
                                                        o +
                                                        '"  sizes="375px" srcset="' +
                                                        o +
                                                        '"><span class="Image__Loader"></span><noscript><img src="' +
                                                        o +
                                                        '" alt="' +
                                                        d +
                                                        '"></noscript></div><div class="Icon Icon--ZOOM_CIRCLE"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g transform="translate(-419 -430)"><g transform="translate(419 430)"><circle id="circle" fill-opacity="0.7" fill="#FFF" cx="25" cy="25" r="25"></circle><g transform="rotate(90 6 25)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="rotate(-45 6 6)"></path><path d="M9.78947368,2.21052632 L2.32840204,9.67159796" transform="scale(1 -1) rotate(45 20.485 0)"></path></g></g></g></g></svg></div></div>';
                                                    $(".js-media").append(r);
                                            }
                                        }
                                        return e;
                                    };
                                    l(a).then(function (e) {
                                        $(".onloadDots").remove(),
                                            $(".pdp_media_skeleton").css("display", "none"),
                                            $(".onloadSkeleton").css("display", "none"),
                                            $(".pdp_swatch_skeleton").css("display", "none"),
                                            $(".pdp_size_skeleton").css("display", "none"),
                                            $(window).scrollTop(0),
                                            $(".js-media").css("content-visibility", "visible"),
                                            $(".Swatches").css("display", "flex"),
                                            $(".product-size").css("display", "block"),
                                            $(".js-media.Mobile").flickity({
                                                prevNextButtons: !1,
                                                pageDots: !0,
                                                adaptiveHeight: !1,
                                                watchCSS: !0,
                                                dragThreshold: 50,
                                                draggable: !0,
                                                initialIndex: 0,
                                                arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
                                            });
                                    });
                                });
                    }
                    let l = $(this).parent().data("title"),
                        n = $(this).data("pid"),
                        c = $(this).data("has_preorder");
                    var p = l.split("|");
                    $(this).parents(".Swatches").find(".changeVariant").removeClass("block-selected"),
                        $(".select-variant").removeClass("block-selected"),
                        $(this).addClass("block-selected"),
                        $(".variantTitle").text(p[p.length - 1]),
                        $("[data-product_show='" + n + "']")
                            .find(".SizesList ")
                            .each(function () {
                                $(this).addClass("no-js"), $(this).removeClass("current-sizelist");
                            }),
                        $("[data-product_show='" + n + "']")
                            .find(".quick-add-sizes-for_" + t)
                            .removeClass("no-js"),
                        $("[data-product_show='" + n + "']")
                            .find(".quick-add-sizes-for_" + t)
                            .addClass("current-sizelist"),
                        setTimeout(() => {
                            $(".current-sizelist .SizeButton:not(.out-of-stock)").first().click();
                        }, 100);
                    let m = $("#cta-btn-pf");
                    c
                        ? (m.addClass("Button--primary call-to-action-btn").removeClass("Button--secondary Button--disabled").removeAttr("disabled"),
                          $("#cta-text").text(window.languages.productFormPreorder),
                          $("#adding-variant").val("").removeAttr("data-title").removeAttr("data-vid"),
                          $(".preorder-text").removeClass("hidden"))
                        : (m.addClass("Button--secondary Button--disabled").attr("disabled", "disabled").removeClass("Button--primary call-to-action-btn"),
                          $("#cta-text").text(window.languages.productFormselectSizeText),
                          $("#adding-variant").val("").removeAttr("data-title").removeAttr("data-vid"),
                          $(".preorder-text").addClass("hidden"));
                }
                if ($(this).hasClass("onHome")) {
                    let u = $(this).data("tag_name");
                    $("#collection_handle").val();
                    let h = $(this).parent().data("title");
                    $(this).find("img").attr("srcset");
                    let v = $(this).data("pid");
                    var p = h.split("|");
                    $(this).parents(".Swatches").find(".changeVariant").removeClass("block-selected"),
                        $(".select-variant").removeClass("block-selected"),
                        $(this).addClass("block-selected"),
                        $(".variantTitle").text(p[p.length - 1]),
                        $("[data-product_show='" + v + "']")
                            .find(".SizesList ")
                            .each(function () {
                                $(this).addClass("no-js");
                            }),
                        $("[data-product_show='" + v + "']")
                            .find(".quick-add-sizes-for_" + u)
                            .removeClass("no-js");
                    let g = $("#cta-btn-pf");
                    g.addClass("Button--secondary Button--disabled").attr("disabled", "disabled").removeClass("Button--primary call-to-action-btn"),
                        $("#cta-text").text(window.languages.productFormselectSizeText),
                        $("#adding-variant").val("").removeAttr("data-title").removeAttr("data-vid");
                }
            }),
            $(document).on("click", ".select-variant", function () {
                if ($(this).hasClass("inputChecked")) {
                    if (history.pushState) {
                        var e = window.location.protocol + "//" + window.location.host + window.location.pathname;
                        window.history.pushState({ path: e }, "", e);
                    }
                    let t = $("#cta-btn-pf");
                    t.addClass("Button--secondary Button--disabled").attr("disabled", "disabled").removeClass("Button--primary call-to-action-btn"),
                        $("#cta-text").text(window.languages.productFormselectSizeText),
                        $("#adding-variant").val("").removeAttr("data-title").removeAttr("data-vid"),
                        $(this).removeClass("block-selected"),
                        $(".select-variant").each(function () {
                            $(this).removeClass("inputChecked");
                        });
                } else {
                    let a = $(this).find("input").data("qty"),
                        i = $(this).find("input").data("available"),
                        s = $(this).find("input").data("variant_id"),
                        o = $(this).find("input").data("title"),
                        d = Math.round(100 * $(this).find("input").data("price")),
                        r = Math.round(100 * $(this).find("input").data("price-compare")),
                        l = $(".ProductMeta__PriceList");
                    r > d
                        ? l.html(`
                        <span class="ProductMeta__Price Price--compareAt Text--strikethrough u-h4">${theme.formatMoney(r, theme.moneyFormat)}</span>
                        <span class="ProductMeta__Price Price--highlight Text--subdued u-h4">${theme.formatMoney(d, theme.moneyFormat)}</span>
                      `)
                        : l.html(`
                        <span class="ProductMeta__Price Price Text--subdued u-h4">${theme.formatMoney(d, theme.moneyFormat)}</span>
                      `),
                        $(this).parents(".SizesList").find(".select-variant").removeClass("block-selected"),
                        $(this).addClass("block-selected");
                    let n = $("#cta-btn-pf"),
                        c = $("#adding-variant"),
                        p = $("#cta-text");
                    if (
                        ($(".select-variant").each(function () {
                            $(this).removeClass("inputChecked");
                        }),
                        history.pushState)
                    ) {
                        var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + s;
                        window.history.pushState({ path: e }, "", e);
                    }
                    !0 == i
                        ? (n.removeClass("Button--secondary Button--disabled").removeAttr("disabled").addClass("Button--primary call-to-action-btn"),
                          c.val(s).attr("data-title", o).attr("data-vid", s),
                          $(".Swatches .SwatchItem .block-selected").data("has_preorder") ? p.text(window.languages.productFormPreorder) : p.text(window.languages.productFormAddToCart),
                          $(this).addClass("inputChecked"))
                        : a > 0
                        ? (n.removeClass("Button--secondary Button--disabled").removeAttr("disabled").addClass("Button--primary call-to-action-btn"),
                          c.val(s).attr("data-title", o).attr("data-vid", s),
                          p.text(window.languages.productFormAddToCart),
                          $(this).addClass("inputChecked"))
                        : ($(this).addClass("inputChecked"),
                          n.addClass("Button--secondary Button--disabled").attr("disabled", "disabled").removeClass("Button--primary call-to-action-btn"),
                          c.val("").removeAttr("data-title").removeAttr("data-vid"),
                          p.text(window.languages.productFormSoldOut));
                }
            });
        let a = document.getElementById("mobile_slider");
        if ($("#mobile_slider").length > 0) {
            var i = new Hammer.Manager(a),
                s = new Hammer.Pinch(),
                o = new Hammer.Rotate();
            s.recognizeWith(o),
                i.add([s, o]),
                i.on("pinchin", function (e) {
                    var t = $("#mobile_slider").attr("data-scale"),
                        a = 0.05 * e.scale;
                    (a = t - a) < 1 && (a = 1), t > 1 && ($("#mobile_slider").attr("data-scale", a), $(".flickity-viewport").css("transform", "scale(" + a + ")"));
                }),
                i.on("pinchout", function (e) {
                    var t = $("#mobile_slider").attr("data-scale"),
                        a = 0.5 * e.scale;
                    a < 1 && (a = 1), a > t && ($("#mobile_slider").attr("data-scale", a), $(".flickity-viewport").css("transform", "scale(" + a + ")"));
                });
        }
    }),
    $(function () {
        "use strict";
        PageInits.collection(".ProductItem__Info .Heading"), PageInits.collection(".ProductItem__Info .ProductItem__PriceList"), PageInits.collection(".ProductItem__Info");
    }),
    $(window).resize(function () {
        PageInits.collection(".ProductItem__Info .Heading"), PageInits.collection(".ProductItem__Info .ProductItem__PriceList"), PageInits.collection(".ProductItem__Info");
    }),
    $(window).scroll(function () {
        PageInits.collection(".ProductItem__Info .Heading"), PageInits.collection(".ProductItem__Info .ProductItem__PriceList"), PageInits.collection(".ProductItem__Info");
    }),
    document.querySelectorAll(".js-popup").forEach((e) => {
        e.querySelectorAll(".js-popup-close").forEach((t) => {
            t.addEventListener("click", function () {
                e.classList.remove("is-active");
            });
        });
    });
const getMyCookie = (e) => {
        let t = document.cookie.match(RegExp(e + "=([^;]+)"));
        if (t) return t[1];
    },
    setMyCookie = (e, t, a) => {
        let i = new Date();
        return (
            a.minutes && i.setTime(i.getTime() + 6e4 * a.minutes),
            a.hours && i.setTime(i.getTime() + 36e5 * a.hours),
            a.days && i.setDate(i.getDate() + a.days),
            (document.cookie = e + "=" + t + "; expires=" + i.toUTCString() + "; path=/"),
            t
        );
    },
    currentHref = window.location.href;
currentHref.includes("same_site=true") && setMyCookie("popupStoreLocations", "yes", { days: 180 }),
    getMyCookie("popupStoreLocations") ||
        (document.querySelector(".js-popup-shops")?.classList.add("is-active"),
        document.querySelectorAll(".js-popup").forEach((e) => {
            e.querySelectorAll(".js-popup-close").forEach((e) => {
                e.addEventListener("click", function () {
                    setMyCookie("popupStoreLocations", "yes", { days: 180 }), document.querySelector("body").classList.remove("is-fixed");
                });
            });
        }),
        document.querySelectorAll("#footer-store-popover .link-store-btn").forEach((e) => {
            e.addEventListener("click", (e) => {
                setMyCookie("popupStoreLocations", "yes", { days: 180 });
            });
        })),
    $(".select-store .select__main .select__title").on("click", function (e) {
        e.preventDefault(), $(this).closest(".select-store").toggleClass("is-open");
    });
const findFrm = setInterval(() => {
    let e = document.getElementById("tidio-chat-iframe");
    if (e) {
        let t = !1,
            a = (a) => {
                for (let i of a) {
                    let s = i.target.getAttribute("style");
                    s.includes("height: 94px") && (t ? (t = !1) : ((t = !0), (e.style.width = "94px")));
                }
            },
            i = new MutationObserver(a);
        i.observe(e, { attributes: !0 }), (e.style.zIndex = 991), e.getAttribute("style")?.includes("height: 94px") && ((t = !0), (e.style.width = "94px")), clearInterval(findFrm);
    }
}, 100);
if (window.MutationObserver) {
    let e = new MutationObserver((e) => {
        e.forEach((e) => {
            $(".slick-slider").slick?.("setPosition");
        });
    });
    e.observe(document.querySelector("html"), { attributes: !0 });
} else console.error("MutationObserver is not supported by your browser.");
!(function () {
    var e = Shopify && Shopify.theme && Shopify.theme.jsCustomizer;
    if (e) {
        var t = e.onControlChange;
        e.onControlChange = function (e) {
            t.apply(this, arguments), e && e.popup && (e.popup.options.autoClose = !1);
        };
    }
})();
